module.exports = __webpack_public_path__ + "7b1c0c4fb8fa6728512d15ea9e760f16.pdf";